import shortUUID from "short-uuid";

export const shortIdGenerator = () => {
  return shortUUID().generate();
};
